// Services
import { tmxApiCall } from '.'

// Utilities
import Logger from '../utility/loggerUtil'

import { LoanLockTypeEnum } from '../constants'

export default {
  async sendVerifyCode (altCustomerId, loanId, requesterName, isVoice) {
    Logger.info('Started Send Verify Code request.')

    return tmxApiCall('post', '/sendverificationcode', {
      customerId: altCustomerId,
      loanId,
      requesterName,
      isVoice
    })
  },

  async verifyCode (loanId, code) {
    Logger.info('Started verify verification Code request.')

    return tmxApiCall('get', '/verificationcodestatus', {
      params: {
        loanId,
        verificationCode: code
      }
    })
  },

  async isLoanRefiAltPartyLocked (loanIds, cognitoId) {
    Logger.info('Started Is Loan Refinance Alternate Party Locked request.')

    return tmxApiCall('get', '/loanlock', {
      params: {
        loanIds,
        profileId: cognitoId,
        lockType: LoanLockTypeEnum.RefiAltPartyLocked
      }
    })
  },

  async setLoanRefiAltPartyLockout (loanId, value) {
    Logger.info('Started set Loan Refinance Alternate Party Lockout request')
    return tmxApiCall('post', '/loanlock', {
      loanId,
      value,
      lockType: LoanLockTypeEnum.RefiAltPartyLocked
    })
  }
}
